module.exports = __webpack_public_path__ + "static/media/cover-login-access-1.6cdabfbc.jpg";